import { useRef, useEffect } from 'react'
import { hsvToRgb } from '../utils/colors'

const RainbowSwatch = () => {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    const { width: diameter } = canvas.getBoundingClientRect()
    const radius = diameter / 2
    canvas.width = diameter
    canvas.height = diameter
    const ctx = canvas.getContext('2d')
    const imdata = ctx.createImageData(diameter, diameter)
    const data = imdata.data
    for (let p = 0, len = data.length; p < len; p += 4) {
      const pix = p / 4
      const x = pix % diameter
      const y = Math.floor(pix / diameter)
      const hue = (Math.PI + Math.atan2(radius - y, radius - x)) / (2 * Math.PI)
      const sat =
        0.1 +
        0.8 *
          (Math.sqrt(Math.pow(radius - x, 2) + Math.pow(radius - y, 2)) /
            radius)
      const val = 1
      const [r, g, b] = hsvToRgb(hue, sat, val)
      data[p] = r
      data[p + 1] = g
      data[p + 2] = b
      data[p + 3] = 255
    }
    ctx.putImageData(imdata, 0, 0)
  }, [])

  return (
    <div className="velorbis-customizer-rainbow-swatch">
      <canvas ref={canvasRef} />
    </div>
  )
}

export default RainbowSwatch
